function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { getDefaultOffset } from '@bydesign-ui/hooks';
import { AxisType, PointType } from '../enum';
import { Region } from './Region';
export var TwoDimensionRegion = function (_Region) {
  _inherits(TwoDimensionRegion, _Region);

  var _super = _createSuper(TwoDimensionRegion);

  function TwoDimensionRegion() {
    var _this;

    _classCallCheck(this, TwoDimensionRegion);

    _this = _super.call(this);
    _this.isTrying = false;
    _this.changeOnEnd = false;
    _this.value = getDefaultOffset();
    _this.tryingValue = getDefaultOffset();

    _this.createPoint('end', PointType.RIGHT_BOTTOM);

    return _this;
  }

  _createClass(TwoDimensionRegion, [{
    key: "updateOptions",
    value: function updateOptions(options) {
      var value = options.value,
          _options$changeOnEnd = options.changeOnEnd,
          changeOnEnd = _options$changeOnEnd === void 0 ? false : _options$changeOnEnd,
          xAxis = options.xAxis,
          yAxis = options.yAxis;
      this.changeOnEnd = changeOnEnd;
      this.value = value;
      this.tryingValue = getDefaultOffset();
      this.isTrying = false;
      this.getAxis(AxisType.HORIZONTAL).updateAxisConfig(xAxis);
      this.getAxis(AxisType.VERTICAL).updateAxisConfig(yAxis);
      this.getPoint('end').updatePointValue();
      this.repaint();
    }
  }, {
    key: "setPointValue",
    value: function setPointValue(part, value, virtual) {
      if (part !== 'end') {
        throw new Error('simple region has only one valid part end');
      }

      if (this.changeOnEnd && virtual) {
        this.tryingValue = value;
        this.getPoint('end').repaint();
        return;
      }

      this.emit('change', value);
    }
  }, {
    key: "getPointValue",
    value: function getPointValue(part) {
      if (part !== 'end') {
        throw new Error('simple region has only one valid part end');
      }

      return this.isTrying ? this.tryingValue : this.value;
    }
  }, {
    key: "isValueSelected",
    value: function isValueSelected(value) {
      return this.isAxisSelected(AxisType.HORIZONTAL, value.x) && this.isAxisSelected(AxisType.VERTICAL, value.y);
    }
  }, {
    key: "isAxisSelected",
    value: function isAxisSelected(type, value) {
      var end = this.isTrying ? this.tryingValue : this.value;

      if (type === AxisType.HORIZONTAL) {
        return value <= end.x;
      }

      if (type === AxisType.VERTICAL) {
        return value <= end.y;
      }

      return false;
    }
  }, {
    key: "getPointByOffset",
    value: function getPointByOffset() {
      return this.getPoint('end');
    }
  }, {
    key: "getSelectedRegion",
    value: function getSelectedRegion() {
      return [{
        x: 0,
        y: 0
      }, this.isTrying ? this.tryingValue : this.value];
    }
  }, {
    key: "getSelectedOffset",
    value: function getSelectedOffset() {
      return [{
        x: 0,
        y: 0
      }, this.getPoint('end').getOffset()];
    }
  }]);

  return TwoDimensionRegion;
}(Region);